// DEV: replace the HUD by one panel-filling block of text so the wearer can set the
// inner FOV ring where reading stops (user, Pico 2026-10-10: "the big text just to see
// the inner ring, once with the original text size then a second run with a bigger one").
// Same panel, same layout viewport as the HUD; the HUD's own roots are hidden meanwhile.
// Driven from the dev console / CDP: game.fovText.show(16) … game.fovText.show(32) … hide().
import { createBox, text } from 'imperial-lib';
import { ensureFont } from './box-patcher.js';

const makeBox = createBox({ text });
const SAMPLE = 'The quick brown fox jumps over the lazy dog 0123456789 ';

let box = null;
let hidden = [];

export async function showFovText(fontSize = 16) {
	hideFovText();
	const font = await ensureFont();
	const vp = globalThis.__guiViewport || { width: window.innerWidth, height: window.innerHeight };
	const lines = Math.ceil(vp.height / (fontSize * 1.2)) + 2;
	const perLine = Math.ceil(vp.width / (fontSize * 0.55));
	box = makeBox({
		width: vp.width, height: vp.height, font, fontSize, lineHeight: 1.2,
		text: SAMPLE.repeat(Math.ceil(lines * perLine / SAMPLE.length)),
		textWrap: true, overflow: 'hidden', color: [1, 1, 1], backgroundColor: [0, 0, 0, 0],
	});
	box.name = 'FOV_TEXT';
	box.userData.layoutIgnore = true;
	for (const c of game.gui.children) if (c.visible) { hidden.push(c); c.visible = false; }
	game.gui.add(box);
	box.updateRenderOrder((game.gui.renderOrder || 10000) + 500);
	box.layout();
	return { fontSize, viewport: vp, deg: +(2 * Math.atan(fontSize * game.gui.scale.x / 2 / 1.5) * 180 / Math.PI).toFixed(2) };
}

export function hideFovText() {
	if (box) { box.parent?.remove(box); box.dispose?.(); box = null; }
	for (const c of hidden) c.visible = true;
	hidden = [];
}
